import React from 'react';

const Contact = () => (
  <section className="contact-section">
    <div className="section">
      <h1>Contact</h1>
    </div>
    <div className="divider"></div>
    <div className="divider"></div>
    <div className="divider"></div>
    <div className="divider"></div>
    <br/><br/>
    <p>Email: ernest.vincent.villa@gmail.com</p>
    <p>Phone number: 289-689-8051</p>
    <div className="section">

    </div>
  </section>
);

export default Contact;